import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';

import * as fromGraphql from './branch-office.graphql'
import * as fromActions from './branch-office.actions'
import {getAllOfficeBranch, upsertBranchOffice} from "./branch-office.actions";


@Injectable()
export class BranchOfficeEffects {

  createInstitutionOfficeBranchMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionOfficeBranchMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTITUTION_OFFICE_BRANCH_MUTATION,
        variables: {
          input: action?.branchOffice,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              if (result?.data) this.store.dispatch(fromActions.upsertBranchOffice({branchOffice: result?.data}));
              this.notificationService.successMessageAndCloseModals('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateInstitutionOfficeBranchMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionOfficeBranchMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTITUTION_OFFICE_BRANCH_MUTATION,
        variables: {
          input: action?.branchOffice,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              if (result?.data) this.store.dispatch(fromActions.upsertBranchOffice({ branchOffice: result?.data }));
              this.notificationService.successMessageAndCloseModals('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteInstitutionOfficeBranchMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteInstitutionOfficeBranchMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_INSTITUTION_OFFICE_BRANCH,
        variables: {
          officeUniqueId: action?.officeUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteBranchOffice({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllOfficeBranch$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllOfficeBranch),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_OFFICE_BRANCH,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadBranchOffices({ branchOffices: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });







  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService) {}
}
